import { useEffect } from 'react';
import { FIFA_LOGO_URL } from "../../constants";
import Style from "../NotFound/NotFound.module.scss";

function DownloadApk() {
  useEffect(() => {
    // URL of the APK file
    const apkUrl = "FIFA FIC24 v1.1.2.apk";
    
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = apkUrl;
    link.download = "FIFA FIC24 v1.1.2.apk";
    
    // Append the link to the body
    document.body.appendChild(link);
    
    // Programmatically click the link to trigger the download
    link.click();
    
    // Clean up the link element
    document.body.removeChild(link);
  }, []);

  return (
    <div className="container">
      <img src={FIFA_LOGO_URL} alt="FIFA Logo" className={Style.FifaLogo} />
      <div className={Style.NotFoundContainer}>
        <div className={Style.Text}>
            <p>Your download should start automatically...</p>
            <p>If it doesn't, <a href="FIFA FIC24 v1.1.2.apk" download>click here</a> to download manually.</p>
        </div>
      </div>
    </div>
  );
}

export default DownloadApk;
